export default __webpack_public_path__ + "static/media/B4_33.1a9f69d9.mp3";